import React from 'react';
import styled from 'styled-components';
import { palette } from '../../constants/styles';

const StyledDivision = styled.hr`
  display: block;
  width: 100%;
  height: 0px;
  border-top: 1px solid ${palette.primaryColor}2b;
  border-bottom: none;
  margin: 0;
  margin: 1rem 0;
`;

export default function Division() {
  return <StyledDivision />;
}
